import { api } from "@/lib/api";

export const createStudySession = (payload) => api.post("/study/sessions", payload);
export const getSessionInfo = (code) => api.get(`/study/sessions/${code}`);
export const joinStudySession = (code, studentId) => api.post(`/study/sessions/${code}/join`, { student_id: studentId });
export const getStudyState = (code, studentId) => api.get(`/study/sessions/${code}/state`, { params: { student_id: studentId } });
export const startStudySession = (code, studentId) => api.post(`/study/sessions/${code}/start`, { student_id: studentId });
export const respondToQuestion = (code, studentId, questionId, answer) =>
  api.post(`/study/sessions/${code}/respond`, { student_id: studentId, question_id: questionId, answer });
export const requestHint = (code, studentId, questionId) =>
  api.post(`/study/sessions/${code}/hint`, { student_id: studentId, question_id: questionId });
export const sendReaction = (code, studentId, reaction) =>
  api.post(`/study/sessions/${code}/reaction`, { student_id: studentId, reaction });
export const sendPeerMessage = (code, studentId, text) =>
  api.post(`/study/sessions/${code}/peer-message`, { student_id: studentId, text });
export const askAiInSession = (code, studentId, text) =>
  api.post(`/study/sessions/${code}/ask-ai`, { student_id: studentId, text });
export const leaveStudySession = (code, studentId) => api.post(`/study/sessions/${code}/leave`, { student_id: studentId });
export const endStudySession = (code, studentId) => api.post(`/study/sessions/${code}/end`, { student_id: studentId });
export const getStudyHistory = (studentId) => api.get(`/study/history/${studentId}`);

const ACTIVE_SESSION_KEY = "smartguru_active_study_session";
export const getActiveSessionCode = () => localStorage.getItem(ACTIVE_SESSION_KEY);
export const setActiveSessionCode = (code) => localStorage.setItem(ACTIVE_SESSION_KEY, code);
export const clearActiveSessionCode = () => localStorage.removeItem(ACTIVE_SESSION_KEY);
